import { Box, Stack, Typography } from '@mui/material'
import React from 'react'
import { ReactFitty } from 'react-fitty'
import Grid from '@mui/material/Grid2';
import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import skills from '../../assets/img/skillsPage/skills.avif'

const Skills = () => {
  return (
    <Grid container spacing={2} height={"100dvh"} sx={{
      backgroundColor: '#e5e8d9',
    }}>
      <Grid size={{ xs: 12, md: 6, lg: 6 }} sx={{
        '@media screen and (max-width: 600px)': {
          display: 'none'
        },
        '@media screen and (min-width: 601px) and (max-width: 900px)': {
          display: 'none'
        },
      }}>
        <Box sx={{
          padding: '0 0 0 100px',
          width: '100%',
          borderRadius: '8px'
        }}>
          <img src={skills} alt="skills" style={{ borderRadius: '8px', width: '100%', height: '100dvh', objectFit: 'contain' }} />
        </Box>
      </Grid>
      <Grid size={{ xs: 12, md: 6, lg: 6 }}>
        <Box sx={{
          padding: '100px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          height: '100%',
          '@media screen and (max-width: 600px)': {
            padding: '40px 10px 80px 10px',
          },
          '@media screen and (min-width: 601px) and (max-width: 900px)': {
            padding: '20px 10px'
          },
          '@media screen and (min-width: 901px) and (max-width: 1200px)': {
            padding: '20px 10px'
          }
        }}>
          <Box>
            <Typography
              color='secondary'
              sx={{
                fontFamily: "Great Vibes",
                textAlign: 'left',
                position: 'relative',
                zIndex: 2,
                width: '100%',
                fontSize: '4rem',
                padding: '0 30px'
              }}>
              Personal
            </Typography>
            <Typography
              sx={{ textAlign: 'center', position: 'relative', zIndex: 1, lineHeight: 0.7, marginTop: "-45px", color: '#fd4002' }}
              component={ReactFitty}
            >
              SKILLS
            </Typography>
          </Box>
          <Box>
            <Stack flexDirection={"row"} gap={"10px"} alignItems={"center"}>
              <Typography
                fontSize={"1.5rem"}
                sx={{
                  color: '#fd4002',
                  '@media screen and (max-width: 600px)': {
                    fontSize: '1.3rem'
                  }
                }}
              >
                Аналитическое мышление
              </Typography>
              <DoubleArrowIcon sx={{ color: '#fd4002', fontSize: '1.7rem' }} />
            </Stack>
            <Typography color='secondary' gutterBottom>
              Умение разбирать сложные задачи, находить оптимальные решения и предвидеть возможные проблемы.</Typography>
          </Box>
          <Box>
            <Stack flexDirection={"row"} gap={"10px"} alignItems={"center"}>
              <Typography
                fontSize={"1.5rem"}
                sx={{
                  color: '#fd4002',
                  '@media screen and (max-width: 600px)': {
                    fontSize: '1.3rem'
                  }
                }}
              >
                Гибкость и адаптивность
              </Typography>
              <DoubleArrowIcon sx={{ color: '#fd4002', fontSize: '1.7rem' }} />
            </Stack>
            <Typography color='secondary' gutterBottom>
              Быстрая адаптация к новым технологиям, постоянное развитие и внедрение лучших практик.</Typography>
          </Box>
          <Box>
            <Stack flexDirection={"row"} gap={"10px"} alignItems={"center"}>
              <Typography
                fontSize={"1.5rem"}
                sx={{
                  color: '#fd4002',
                  '@media screen and (max-width: 600px)': {
                    fontSize: '1.3rem'
                  }
                }}
              >
                Внимание к деталям
              </Typography>
              <DoubleArrowIcon sx={{ color: '#fd4002', fontSize: '1.7rem' }} />
            </Stack>
            <Typography color='secondary' gutterBottom>
              Чистый, читаемый и эффективный код, который делает продукт стабильным и качественным.</Typography>
          </Box>
          <Box>
            <Stack flexDirection={"row"} gap={"10px"} alignItems={"center"}>
              <Typography
                fontSize={"1.5rem"}
                sx={{
                  color: '#fd4002',
                  '@media screen and (max-width: 600px)': {
                    fontSize: '1.3rem'
                  }
                }}
              >
                Коммуникабельность
              </Typography>
              <DoubleArrowIcon sx={{ color: '#fd4002', fontSize: '1.7rem' }} />
            </Stack>
            <Typography color='secondary' gutterBottom>
              Развитие навыков общения, ведения диалогов и командной работы.</Typography>
          </Box>
          <Box>
            <Stack flexDirection={"row"} gap={"10px"} alignItems={"center"}>
              <Typography
                fontSize={"1.5rem"}
                sx={{
                  color: '#fd4002',
                  '@media screen and (max-width: 600px)': {
                    fontSize: '1.3rem'
                  }
                }}
              >
                Ответственность и самостоятельность
              </Typography>
              <DoubleArrowIcon sx={{ color: '#fd4002', fontSize: '1.7rem' }} />
            </Stack>
            <Typography color='secondary' gutterBottom>
              Способность вести проект от идеи до реализации, принимая решения без лишнего контроля.</Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  )
}

export default Skills